// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../index';

import { StoneCrystalTranslationFragmentDoc } from './stoneCrystalTranslation.fragment.generated';
export const StoneCrystalFragmentDoc = `
    fragment stoneCrystal on StoneCrystal {
  systemCode
  translation(locale: $locale) {
    ...stoneCrystalTranslation
  }
}
    `;